import { ActionType } from '../infrastructure/actionTypes';
import { ITechReferenceSheet } from '../infrastructure/interfaces';

export default (list: ITechReferenceSheet[] = [], action: any) => {
  switch (action.type) {
    case ActionType.GET_AGRONOMY_REFERENCE_SHEETS_DONE:
      const { agronomyReferenceSheets } = action;
      return agronomyReferenceSheets
    case ActionType.EDIT_AGRONOMY_REFERENCE_SHEET_DONE:
        const { updatedAgronomyReferenceSheet } = action;
        const toggledList = list.map((t) => {
          return (t.id == updatedAgronomyReferenceSheet.id) ? updatedAgronomyReferenceSheet : t
        });
        return toggledList
    case ActionType.CREATE_AGRONOMY_REFERENCE_SHEET_DONE:
      const { newAgronomyReferenceSheet } = action;
      return list.concat(newAgronomyReferenceSheet);
    default:
      return list;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/agronomyReferenceSheetList.ts